export const emailValidator = (value: string): any => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(String(value).toLowerCase());
};

export const emailDomainValidator = (value: string): any => {
  // check not more than 65 characters
  const pattern = /^[a-zA-Z0-9][a-zA-Z0-9]*[-]?[a-zA-Z0-9]*[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
  return pattern.test(String(value).toLowerCase());
};

export const numberOnly = (value: string): string => {
  if (value) {
    return value.replace(/[^0-9]/g, '');
  } else {
    return '';
  }
};

export const floatingNumbersValidator = (value: string): boolean => {
  const pattern = /^\d+\.\d{0,2}$/;
  return pattern.test(value);
};
